import React, { useState, useEffect } from 'react';
import { Icon } from '../icon';
import styles from './pagination.module.scss';
import Button from '../button/button';

type Props = {
  activePage: number;
  itemsPerPage: number;
  totalItems: number;
  paginate: (page: number) => void;
  paginationRange?: number;
  className?: string;
};
const Pagination = (props: Props) => {
  const { activePage, itemsPerPage, totalItems, paginate, paginationRange = 5 } = props;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const step = (paginationRange - 1) / 2;
  const [range, setRange] = useState<any>([]);

  const goToPage = (page: number) => {
    window.scrollTo(0, 0);
    paginate(page);
  };

  const getPartialRange = () => {
    if (activePage < paginationRange - step) {
      return paginationRange - activePage;
    } else if (activePage + paginationRange - step > totalPages) {
      return Math.abs(totalPages - activePage - paginationRange);
    } else {
      return step;
    }
  };

  const createRange = () => {
    if (totalPages < paginationRange) {
      setRange([...Array(totalPages).keys()]);
    } else {
      const start = Math.max(activePage - getPartialRange(), 0);
      const end = Math.min(start + paginationRange, totalPages);
      const rangeArray = [...Array(end - start).keys()];
      setRange(rangeArray.map((r, i) => start + i));
    }
  };

  useEffect(() => {
    createRange();
    // eslint-disable-next-line
  }, [totalItems, activePage]);

  if (!totalItems || totalItems === 0 || totalItems <= itemsPerPage) {
    return null;
  }

  return (
    <div className={`${styles.paginationContainer} ${props.className || ''}`}>
      <div className={styles.pages}>
        <Button disabled={Number(activePage) === 0} onClick={() => goToPage(Number(activePage) - 1)} color="transparent" mode="solid">
          <Icon content="arrowLeft" />
        </Button>
        {range?.map((item, index) => (
          <Button
            key={index}
            onClick={() => goToPage(item)}
            className={`${styles.pageButton} ${item === Number(activePage) ? styles.active : ''}`}
          >
            {item + 1}
          </Button>
        ))}
        <Button
          disabled={Number(activePage) === totalPages - 1}
          onClick={() => goToPage(Number(activePage) + 1)}
          color="transparent"
          mode="solid"
        >
          <Icon content="arrowRight" />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
